import { makeStyles } from "@material-ui/core";
import { VIMEO_VIDEO_EMBED_STYLES } from "view/components/RichText/styles";

const styles = makeStyles(() => ({
  root: {
    "& p": {
      margin: 0,
    },
    "& a": {
      display: "inline-block",
      maxWidth: "100%",
      verticalAlign: "bottom",
      wordBreak: "normal",
      overflowWrap: "break-word",
    },
    "& img": {
      maxWidth: "100%",
    },
    ...VIMEO_VIDEO_EMBED_STYLES,
    lineHeight: 2,

    "& *:last-child": {
      marginBottom: 0,
    },
  },
}));

export default styles;
